export const CONVERSATION_STORAGE_KEY = 'agent-insights-conversation';
const CLEAR_SIGNAL_STORAGE_KEY = 'agent-insights-clear-signal';

export const clearConversationFromStorage = () => {
  try {
    sessionStorage.removeItem(CONVERSATION_STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear conversation from session storage:', error);
  }
};

/**
 * Read the last conversationClearSignal value acknowledged by AgentInsights.
 * Returns null when no value has been stored yet (first mount / new tab).
 */
export const loadClearSignalFromStorage = (): number | null => {
  try {
    const raw = sessionStorage.getItem(CLEAR_SIGNAL_STORAGE_KEY);
    return raw !== null ? Number(raw) : null;
  } catch {
    return null;
  }
};

export const saveClearSignalToStorage = (signal: number) => {
  try {
    sessionStorage.setItem(CLEAR_SIGNAL_STORAGE_KEY, String(signal));
  } catch {
    // best-effort
  }
};
